import { render, staticRenderFns } from "./AddClue.vue?vue&type=template&id=12b4b987&scoped=true"
import script from "./AddClue.vue?vue&type=script&lang=js"
export * from "./AddClue.vue?vue&type=script&lang=js"
import style0 from "./AddClue.vue?vue&type=style&index=0&id=12b4b987&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4b987",
  null
  
)

export default component.exports